<template>
    <div>
        <div v-if="listItem.length > 0">
            <div v-for="(item, index) in listItem" :key="index">
                <div class="draft-item" @click="handle(item)">
                    <h4 class="ell">
                        【{{ item.category_name }}】{{ item.item_name }}
                    </h4>
                    <p class="ell">发起时间: {{ item.send_time }}</p>
                    <p class="ell">接收时间：{{ item.receive_time }}</p>

                    <div class="box">
                        <p class="ell">发起人：{{ item.sender_name }}</p>
                        <p class="ell">来源：{{ item.source_name }}</p>
                    </div>
                </div>
            </div>
        </div>

        <div v-else>
            <div class="no-data">
                <p>暂无数据</p>
            </div>
        </div>
    </div>
</template>

<script>
    import {
        queryReceivedEximplItemList,
        draftsEximplPublicPage,
        querysendGridEximplListNew,
        initiatedEximplPublicPage,
        querysendMyGridEximplPublicPage,
    } from "@/api/MineMore"
    export default {
        name: "ExampleItem",
        data: () => ({
            listItem: [],
            total: 0,
            pageIndex: 0,
            pageSize: 10000,
        }),
        created() {
            this.getInfo()
        },
        methods: {
            getInfo() {
                var params = {
                    source_code: this.$route.query.source_code,
                    type_code: this.$route.query.type_code,
                    pageIndex: this.pageIndex ? this.pageIndex : 0,
                    pageSize: this.pageSize ? this.pageSize: 10000,
                }
                console.log(params,8888);
                switch (this.$route.query.sourceType) {
                    case "receivedGridExample":
                        this.queryReceivedEximplItemList(params)
                        break
                    case "sendGridEximpl":
                        this.querysendGridEximplListNew(params)
                        break
                    case "initiatedEximpl":
                        this.initiatedEximplPublicPage(params)
                        break
                    case "draftsEximpl":
                        this.draftsEximplPublicPage(params)
                        break
                    case "sendMyGridEximpl":
                        this.querysendMyGridEximplPublicPage(params)
                        break
                }
            },
            queryReceivedEximplItemList(params) {
                queryReceivedEximplItemList(params).then(resp => {
                    if (resp.data) {
                        this.listItem = resp.data
                        console.log("this.listItem: ", this.listItem)
                        this.total = resp.total
                    }
                })
            },
            draftsEximplPublicPage(params) {
                draftsEximplPublicPage(params).then(resp => {
                    if (resp.data) {
                        this.listItem = resp.data
                        this.total = resp.total
                    }
                })
            },
            querysendGridEximplListNew(params) {
                querysendGridEximplListNew(params).then(resp => {
                    if (resp.data) {
                        this.listItem = resp.data
                        this.total = resp.total
                    }
                })
            },
            initiatedEximplPublicPage(params) {
                initiatedEximplPublicPage(params).then(resp => {
                    if (resp.data) {
                        this.listItem = resp.data
                        this.total = resp.total
                    }
                })
            },
            querysendMyGridEximplPublicPage(params) {
                querysendMyGridEximplPublicPage(params).then(resp => {
                    if (resp.data) {
                        this.listItem = resp.data
                        this.total = resp.total
                    }
                })
            },
            handle(item) {
                if (item && item.source_code == "serviceall") {
                    location.href = item.detailMobileUrl
                } else {
                    window.location.href = item.detailMobileUrl
                }
            },
        },
    }
</script>

<style lang="scss" scoped>
    .no-data {
        width: 100%;
        height: 100vh;
        display: flex;
        justify-content: center;
        align-items: center;
        p {
            font-size: 14px;
            color: #999;
        }
    }
    .draft-item {
        padding: 15px;
        padding-right: 180px;
        margin: 15px auto;
        border: 1px solid #e5e5e5;
        border-radius: 5px;
        background: #fff;
        position: relative;
        h4 {
            height: 30px;
            line-height: 30px;
            font-size: 14px;
        }
        p {
            line-height: 20px;
            font-size: 12px;
            color: #999;
        }
        .box {
            width: 145px;
            padding: 10px 0;
            text-align: center;
            position: absolute;
            right: 15px;
            top: 38px;
            border-radius: 5px;
            p {
                font-size: 14px;
                color: #999;
                text-align: left;
            }
        }
    }

    .ell {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
</style>
